function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

export function campaignCurrentDay(campaign) {
  const total = Number(campaign?.days_total) || 0;
  if (total <= 0) return 0;

  if (campaign?.current_day != null) {
    return clamp(Number(campaign.current_day) || 0, 0, total);
  }

  const elapsed = Number(campaign?.days_elapsed) || 0;
  const remaining = Number(campaign?.days_remaining) || 0;
  if (remaining <= 0) return total;
  if (campaign?.state === "draft") return 0;
  return clamp(elapsed + 1, 1, total);
}

export function campaignTimePct(campaign) {
  const total = Number(campaign?.days_total) || 0;
  if (total <= 0) return 0;
  return Math.min(100, Math.round((campaignCurrentDay(campaign) / total) * 100));
}

export function campaignTimeDetail(campaign) {
  const total = Number(campaign?.days_total) || 0;
  if (total <= 0) return "";

  const currentDay = campaignCurrentDay(campaign);
  if (currentDay <= 0) return `Starts soon (${total} days)`;

  return `Day ${currentDay} of ${total}`;
}
